var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignupPrincipBriznostiKomunikacije(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 165 165",
    style: {
      enableBackground: "new 0 0 165 165"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6E5DD8;}\n\t.st1{fill:#FA7268;}\n\t.st2{fill:#AA6276;}\n\t.st3{fill:#159497;}\n\t.st4{fill:none;stroke:#6E5DD8;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#159497;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st6{fill:#231F20;}\n\t.st7{fill:none;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st10{fill:#6E5DD8;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#AA6276;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st13{fill:#FFFFFF;}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st16{fill:#FFFFFF;stroke:#6E5DD8;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:#FFFFFF;stroke:#159497;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st19{fill:#FFFFFF;stroke:#AA6276;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st20{fill:#FA7268;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st22{fill:#FA7267;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 72.4,
    cy: 66.6,
    rx: 60.4,
    ry: 38.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.4,
    y: 87.4,
    className: "st1",
    width: 75.5,
    height: 48.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.5,11.9c0,11.9-9.7,21.6-21.6,21.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M101.8,131.6c0,11.9-9.7,21.6-21.6,21.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M28,67.5c5.8-4.8,12.1-8.9,18.8-12.2c3.2-1.6,7.3-2.9,10.2-0.9c5.1,3.4,2.7,13.8,8.7,15.5 c1.6,0.5,3.4,0.1,5-0.5c2.9-1,5.6-2.4,8-4.2c3.1-2.3,6.4-5.4,10.3-4.7c1.3,0.2,2.4,0.9,3.6,1.5c7.5,3.7,16.6,3.8,24.2,0.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 78.6,
    cy: 111.8,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 99.2,
    cy: 111.8,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 119.7,
    cy: 111.8,
    r: 7.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupPrincipBriznostiKomunikacije);
export default __webpack_public_path__ + "static/media/Signup-princip_briznosti_komunikacije.8c3d575e5f8b51f3c34f0166692b397a.svg";
export { ForwardRef as ReactComponent };